import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['star'];

  connect() {
    this.value = this.element.dataset.initialValue || null;
    this.setInitialValue();
  }

  select(event) {
    const elm = this.getElementFromEvent(event);
    if (!elm) return;

    this.value = elm.dataset.value;
    this.element.querySelector('select').value = this.value;
    this.element.querySelector('select').dispatchEvent(new Event('change'));
  }

  submit(event) {
    const elm = this.getElementFromEvent(event);
    if (!elm) return;

    const value = elm.dataset.value;

    this.element.querySelector('select').value = value;
    const form = this.element.querySelector('form') || this.element.closest('form');
    if (form) form.submit();
  }

  enter(event) {
    const elm = this.getElementFromEvent(event);
    if (!elm) return;

    const value = elm.dataset.value;

    this.starTargets.forEach((star) => {
      star.classList.remove('text-amber-500');
      star.classList.add('text-gray-500');
    });
    this.starTargets.slice(0, value).forEach((star) => {
      star.classList.add('text-amber-500');
      star.classList.remove('text-gray-500');
    });
  }

  leave() {
    this.starTargets.forEach((star) => {
      star.classList.remove('text-amber-500');
      star.classList.add('text-gray-500');
    });

    this.setInitialValue();
  }

  setInitialValue() {
    if (this.value) {
      this.starTargets.slice(0, this.value).forEach((star) => {
        star.classList.remove('text-gray-500');
        star.classList.add('text-amber-500');
      });
    }
  }

  getElementFromEvent(event) {
    event.preventDefault();
    return event.target.dataset.starRatingTarget === 'star'
      ? event.target
      : event.target.closest('button');
  }
}
